export let secure_cookie_options = location.protocol !== 'https:' ? '' : ';secure;samesite=lax'; /* samesite=strict has more problems in some browsers */

const initCookieBanner = () => {
  document.getElementById('ccb-loading').remove();
  document.getElementById('ccb-panel').removeAttribute('style');

  const cookieSetInputs = document.querySelectorAll('#ccb-panel .cookie-set input');

  cookieSetInputs.forEach(input => {
    if (input.checked || initVals.accept_cookies['essential']) {
      document.querySelector('#cookie-settings-choice').classList.remove('hide');
      document.querySelector('#cookie-settings-all').classList.add('hide');
    }
  });

  const infoButtons = document.querySelectorAll('#ccb-panel button.info');

  infoButtons.forEach(btn => {
    btn.addEventListener('click', e => {
      e.currentTarget.parentElement.parentElement.classList.toggle('showinfo');
    });
  });

  cookieSetInputs.forEach(input => {
    input.addEventListener('change', e => {
      const inputElem = e.currentTarget;
      const cookieSettingsChoice = document.querySelector('#cookie-settings-choice');
      const cookieSettingsAll = document.querySelector('#cookie-settings-all');

      if (inputElem.checked) {
        cookieSettingsChoice.classList.remove('hide');
        cookieSettingsAll.classList.add('hide');
      } else if (!initVals.accept_cookies['essential']) {
        cookieSettingsChoice.classList.add('hide');
        cookieSettingsAll.classList.remove('hide');

        cookieSetInputs.forEach(inputTest => {
          if (inputTest.checked) {
            cookieSettingsChoice.classList.remove('hide');
            cookieSettingsAll.classList.add('hide');
          }
        });
      }
    });
  });

  const ccbPanelInfo = document.querySelector('#ccb-panel-info');

  if (ccbPanelInfo) {
    document.querySelector('#ccb-template').classList.remove('show');
    document.querySelector('#ccb-template').classList.add('hide');
  }

  const ccbPanelLinks = document.querySelector('#ccb-template #cookie-settings a');

  if (ccbPanelLinks) {
    ccbPanelLinks.addEventListener('click', e => {
      document.querySelector('#ccb-template').classList.remove('show');
      document.querySelector('#ccb-template').classList.add('hide');
    });
  }

  //ACCEPT COOKIES
  const cookieSettingsChoice = document.querySelector('#cookie-settings-choice');

  if (cookieSettingsChoice) {
    cookieSettingsChoice.addEventListener('click', e => {
      e.preventDefault();

      const cookieSettingsChoice = document.querySelector('#cookie-settings-choice');
      const cookieSettingsAll = document.querySelector('#cookie-settings-all');

      set_cookie_options('choice');
      accept_cookies();

      cookieSettingsChoice.classList.remove('hide');
      cookieSettingsAll.classList.add('hide');
    });
  }

  const cookieSettingsAll = document.querySelector('#cookie-settings-all');

  if (cookieSettingsAll) {
    cookieSettingsAll.addEventListener('click', e => {
      e.preventDefault();

      document.querySelectorAll('#cookie-settings input[type=checkbox]').forEach(input => {
        input.checked = true;
      });
      set_cookie_options('all');
      accept_cookies();
    });
  }

  const cookieSettingsMinimal = document.querySelector('#cookie-settings-minimal');

  if (cookieSettingsMinimal) {
    cookieSettingsMinimal.addEventListener('click', e => {
      e.preventDefault();

      //clear options
      document.querySelectorAll('#cookie-settings input[type=checkbox]').forEach(check => {
        check.checked = false;
      });
      set_cookie_options('minimal');
      accept_cookies();
    });
  }

  const cookieSettingsChange = document.querySelectorAll('.cookie-settings-change');

  cookieSettingsChange.forEach(input => {
    input.addEventListener('click', e => {
      e.preventDefault();

      show_cookies();
    });
  });

  if (document.querySelector('#privacy, .privacy, .cookie-table')) {
    document.querySelector('#ccb-template').classList.remove('show');
  }
};

/* COOKIES */
const set_cookie_options = selectionType => {
  if (cookieOptions) {
    for (var c in cookieOptions) {
      if (typeof cookieOptions[c] !== 'function') {
        const cookieSettings = document.querySelector(`#cookie-settings-${c}`);
        if (cookieSettings) {
          if (selectionType == 'all') {
            cookieOptions[c] = true;
          } else if (selectionType == 'minimal') {
            cookieOptions[c] = false;
          } else {
            cookieOptions[c] = cookieSettings.checked;
          }
        } else {
          cookieOptions[c] = false;
        }
      }
    }
  }
};

const accept_cookies = () => {
  var date = new Date();
  date.setTime(date.getTime() + 30 * 24 * 60 * 60 * 1000);
  cookieOptions['essential'] = true;

  if (initVals.cookieDomain && initVals.cookieDomain != '') {
    document.cookie = '_accept_cookies=' + JSON.stringify(cookieOptions) + ';path=/;domain=' + initVals.cookieDomain + '; expires=' + date.toGMTString() + secure_cookie_options;
  } else {
    document.cookie = '_accept_cookies=' + JSON.stringify(cookieOptions) + ';path=/;expires=' + date.toGMTString() + secure_cookie_options;
  }

  const ccbTemplate = document.querySelector('#ccb-template');
  if (ccbTemplate) {
    ccbTemplate.classList.remove('show');
  }

  if (cookieOptions && initVals.ga != '') {
    gtag('consent', 'update', {
      analytics_storage: cookieOptions['analytical'] ? 'granted' : 'denied',
    });

    gtag('consent', 'update', {
      ad_storage: cookieOptions['marketing'] ? 'granted' : 'denied',
    });

    if (cookieOptions['marketing']) {
      location.reload(true);
    }
  }
};

const show_cookies = () => {
  const ccbTemplate = document.querySelector('#ccb-template');
  if (ccbTemplate) {
    ccbTemplate.classList.add('show');
  }
};

export default initCookieBanner;
